import { createSelector } from "reselect";

import { EntityTypesSupportingFieldCustomization } from "@mapmycustomers/shared/types/entity";

import { RootState } from "@app/store/rootReducer";

const schemaState = (state: RootState) => state.schema;

export const getEntitySchemaFields = createSelector(
  [schemaState, (_, entityType: EntityTypesSupportingFieldCustomization) => entityType],
  (state, entityType) => state.entities[entityType]
);

export const getAvailableEntitySchemaFields = createSelector(
  [
    (state: RootState) => state,
    (_, entityType: EntityTypesSupportingFieldCustomization) => entityType,
  ],
  (state, entityType) => {
    return getEntitySchemaFields(state, entityType).filter((schemaField) => !schemaField.archived);
  }
);
